import { Tooltip, TooltipProps, ComponentStyleConfig } from "@chakra-ui/react";
import { mode, cssVar, StyleFunctionProps } from "@chakra-ui/theme-tools";

const $bg = cssVar("tooltip-bg");
const $arrowBg = cssVar("popper-arrow-bg");

const ToolTipComponentStyle: ComponentStyleConfig = {
  baseStyle: (props: StyleFunctionProps) => {
    const bg = mode("gray.900", "gray.300")(props);

    return {
      [$arrowBg.variable]: [$bg.reference],
      [$bg.variable]: `colors.${bg}`,
      bg: [$bg.reference],
      borderRadius: "base",
      fontSize: "xs",
      py: 1,
      px: 2
    };
  }
};

export { Tooltip, ToolTipComponentStyle };

export type { TooltipProps };
